<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-flex text-center>
            <v-img
                :src="require('@/assets/images/error.svg')"
                class="d-inline-flex mb-8"
            ></v-img>
            <div class="common-text text-center">
                Что-то пошло не так :( <br>
                Попробуйте отсканировать QR-код ещё раз или обратитесь на ресепшен
            </div>
        </v-flex>
    </v-container>
</template>

<script>
export default {
    name: 'EmptyPage',
    created() {
        if (this.$route.query.master_key) {
            this.$router.push({name: "master", query: this.$route.query});
        }
    },
}
</script>